import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import { fontWeight, fontSize, lineHeight } from "../../../../constants/typography";
import { NeutralColors } from "../../../../constants/colors";
import mediaQueries from "../../../../util/mediaqueries";
import styled from 'styled-components';
import GingerLink from "../../../link";
export var Link = styled(GingerLink).withConfig({
  componentId: "sc-16px4z8-0"
})(["display:block;font-weight:", ";font-size:", ";line-height:", ";transition:opacity 150ms ease-in;text-decoration:underline;cursor:pointer;color:", ";&:hover{color:", ";}"], fontWeight.regular, fontSize.xSmall, lineHeight.large, function (_ref) {
  var color = _ref.color;
  return color;
}, NeutralColors.Grey500);
export var LinkWrapper = styled.div.withConfig({
  componentId: "sc-16px4z8-1"
})(["", ""], mediaQueries.md(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n  "]))))));
export var LinkSeparator = styled.span.withConfig({
  componentId: "sc-16px4z8-2"
})(["&::before{content:'\u2014';margin:0 10px;font-weight:", ";display:none;}", ""], fontWeight.regular, mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    &::before {\n      display: initial;\n    }\n  "]))))));
export var BlankLinkSeparator = styled(LinkSeparator).withConfig({
  componentId: "sc-16px4z8-3"
})(["&::before{content:' ';}"]);